<template>
  <Modal
    :show="showModal"
    container-class="atb-w-1/3"
    body-class="atb-border-none"
    header-class="about-modal-header"
    footer-class="atb-flex atb-flex-row atb-justify-end atb-gap-8"
    @onModalClose="closeAboutHandler"
  >
    <template #header>
      <span> {{ $t('aboutATB') }}</span>
    </template>
    <template #body>
      <div class="atb-text-sm atb-grid atb-grid-cols-2 atb-gap-4 atb-py-4">
        <span>
          {{ $t('atbVersion') }}
        </span>
        <span>
          {{ version }}
        </span>
        <span>
          {{ $t('frontendVersion') }}
        </span>
        <span>
          {{ frontendVersion }}
        </span>
        <span>
          {{ $t('experianProtectedEnabled') }}
        </span>
        <span>
          {{ experianProtected }}
        </span>
        <span>
          {{ $t('deploymentEnabled') }}
        </span>
        <span>
          {{ deployCode }}
        </span>
        <span>
          {{ $t('committingCodeEnabled') }}
        </span>
        <span>
          {{ commitCode }}
        </span>
      </div>
    </template>
    <template #footer="{ closeModal }">
      <Button
        motif="primary"
        @click="closeModal"
      >
        {{ $t('close') }}
      </Button>
    </template>
  </Modal>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import aboutApi from '@/app/shared/services/about-service';
  import Modal from '@atb-ui/eds-vue/src/components/Modal.vue';
  import Button from '@atb-ui/eds-vue/src/components/Button.vue';
  import { version as packageVersion } from '../../../../package.json';

  export default defineComponent({
    name: 'About',
    emits: ['closeAbout'],
    data() {
      return {
        showModal: true,
        version: '',
        frontendVersion: '',
        commitCode: '',
        deployCode: '',
        experianProtected: '',
      };
    },
    components: {
      Modal,
      Button,
    },
    mounted() {
      // Relative to the app's base path: several clients can share one hostname
      // (e.g. /chase/dev and /788628/dev), so the root path is another client's web UI.
      const basePath = (config?.VUE_APP_BASE_PATH || '').replace(/\/$/, '');
      fetch(`${basePath}/webui.version`).then((res) => {
        if (res.ok) res.text().then((val) => (this.frontendVersion = val));
        else this.frontendVersion = packageVersion;
      });
      aboutApi.getAboutDetails().then((resp) => {
        const { version, commitCode, deployCode, experianProtected } =
          resp.data.data;

        this.version = version;
        this.commitCode = commitCode;
        this.deployCode = deployCode;
        this.experianProtected = experianProtected;
      });
    },
    methods: {
      closeAboutHandler() {
        this.showModal = false;
        this.$emit('closeAbout');
      },
    },
  });
</script>
